import React from "react";
import BaseView from "../common/BaseView";
import { columns } from "./config";
import { getFundedTransactions } from "../../../Api";
import withData from "../../Data/withData";

function View(props: any) {
  return (
    <BaseView
      columns={columns}
      title="Funded Transactions"
      subtitle="These are companies that have successfully completed the journey and have fully funded."
      {...props}
    ></BaseView>
  );
}

export default withData(View, getFundedTransactions);
